export const handbookResourceType = "handbook" as const;

export const createHandbookResoucePath = (companyId: string) => {
  return `/companies/${companyId}/handbooks`;
};

export const deleteHandbookResoucePath = (
  companyId: string,
  handbookId: string
) => {
  return `/companies/${companyId}/handbooks/${handbookId}`;
};

export const getHandbookResourcePath = (
  companyId: string,
  handbookId: string
) => {
  return `/companies/${companyId}/handbooks/${handbookId}`;
};

export const editHandbookResourcePath = (
  companyId: string,
  handbookId: string
) => {
  return `/companies/${companyId}/handbooks/${handbookId}`;
};
